import { FaStar } from "react-icons/fa";
import styles from "./reviewsRatingSummary.module.scss";

export type RatingSummaryData = {
  averageRating: number;
  totalReviews: number;
  distribution: { stars: number; count: number }[];
};

const DEFAULT_RATING_DATA: RatingSummaryData = {
  averageRating: 0,
  totalReviews: 0,
  distribution: [
    { stars: 5, count: 0 },
    { stars: 4, count: 0 },
    { stars: 3, count: 0 },
    { stars: 2, count: 0 },
    { stars: 1, count: 0 },
  ],
};

type ReviewsRatingSummaryProps = {
  data?: RatingSummaryData | null;
};

const ReviewsRatingSummary = ({ data }: ReviewsRatingSummaryProps) => {
  const { averageRating, totalReviews, distribution } =
    data ?? DEFAULT_RATING_DATA;

  const renderStars = () => {
    const stars = [];
    const fullStars = Math.floor(averageRating);
    const hasHalfStar = averageRating % 1 >= 0.5;

    for (let i = 1; i <= 5; i++) {
      if (i <= fullStars) {
        stars.push(<FaStar key={i} />);
      } else if (i === fullStars + 1 && hasHalfStar) {
        stars.push(
          <span key={i} className={styles.halfStarWrapper}>
            <FaStar className={styles.emptyStar} />
            <FaStar
              style={{
                clipPath: "inset(0 50% 0 0)",
              }}
            />
          </span>
        );
      } else {
        stars.push(<FaStar key={i} className={styles.emptyStar} />);
      }
    }

    return stars;
  };

  return (
    <div className={styles.ratingSummary}>
      <div className={styles.ratingContent}>
        <div className={styles.barsSection}>
          {distribution.map(({ stars, count }) => (
            <div key={stars} className={styles.barRow}>
              <span className={styles.starLabel}>{stars}</span>
              <div className={styles.barTrack}>
                <div
                  className={styles.barFill}
                  style={{
                    width: `${totalReviews ? (count / totalReviews) * 100 : 0}%`,
                  }}
                />
              </div>
            </div>
          ))}
        </div>

        <div className={styles.summarySection}>
          <span className={styles.averageRating}>
            {averageRating.toFixed(1)}
          </span>
          <div className={styles.stars}>{renderStars()}</div>
          <span className={styles.totalReviews}>
            {totalReviews.toLocaleString()} reviews
          </span>
        </div>
      </div>
    </div>
  );
};

export default ReviewsRatingSummary;
